module.exports = __webpack_public_path__ + "assets/img/Cricket-Club-Bloemendaal.4ebc79a9.png";